
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'1-2'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            시스템 관리 - 사용자 {{ $route.query.admin_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.admin_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='admin_name'>사용자명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'admin_name'
                maxLength="100"
                placeholder = "사용자명을 입력해 주세요."
                v-model="formData.adminName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.adminNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='menu_permission_ID_admin'>메뉴권한<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="menu_permission_ID_admin"
                v-model="formData.menuPermissionIDAdmin"
              >
                <option
                  v-for="item in statusData.menuPermissionArray"
                  :key="item.menu_permission_ID"
                  :value="item.menu_permission_ID"
                >
                  {{ item.menu_permission_name }}
                </option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='admin_login_ID'>로그인 ID<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id='admin_login_ID'
                maxLength="20"
                placeholder = "아래 내용 확인 후 로그인 ID를 입력해 주세요."
                v-model="formData.adminLoginID"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.adminLoginIDError}}</p>
          </div>

          <div class="Admin_PageInfo pdl15 mgb40">
            <p>로그인 ID 입력 안내</p>
            <p>1. 아이디는 최소 6자 이상 입력해야 합니다.</p>
            <p>2. 한글 및 특수문자는 입력할 수 없습니다.</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='admin_password'>로그인 비밀번호</label>
              <input
                class="Admin_PageDetail_inputText"
                type='password'
                id = 'admin_password'
                maxLength="20"
                placeholder = "아래 내용 확인 후 비밀번호를 입력해 주세요."
                v-model="formData.adminPassword"
              />
            </div>
          </div>

          <div class="Admin_PageInfo pdl15 mgb40">
            <p>로그인 비밀번호 입력 안내</p>
            <p>1. 수정 시 비밀번호 변경이 필요하면 변경할 비밀번호를 입력 후 수정하면 됩니다.</p>
            <p>2. 수정 시 비밀번호 변경이 필요하지 않다면 빈칸으로 수정하면 됩니다.</p>
            <p>3. 비밀번호는 최소 8자리/ 숫자, 특수문자 각 1회 이상으로 설정해야 합니다.</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='admin_activate'>활성화 여부</label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="admin_activate"
                v-model="formData.adminActivate"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  insert_admin,
  get_admin_one,
  update_admin,
  get_menu_permission_status_1
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminManagementAdd',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter,
    Spiner: Spiner

  },
  setup () {
    return {
      formData: ref({
        adminName: '',
        menuPermissionIDAdmin: 1,
        adminLoginID: '',
        adminPassword: '',
        adminActivate: 1
      }),
      errorData: ref({
        adminNameError: '',
        adminLoginIDError: ''
      }),
      statusData: ref({
        spinnerStatus: false,
        menuPermissionArray: []
      })
    }
  },
  methods: {
    check_form: function () {
      let continue_add = true
      if (this.formData.adminName === '') {
        this.errorData.adminNameError = '사용자명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.adminNameError = ''
      }
      if (this.formData.adminLoginID === '') {
        this.errorData.adminLoginIDError = '로그인 ID를 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.adminLoginIDError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.admin_ID === undefined) {
          insert_admin(
            this.formData.menuPermissionIDAdmin,
            this.formData.adminLoginID,
            this.formData.adminPassword,
            this.formData.adminName,
            this.formData.adminActivate
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminManagement'
          })
        } else {
          update_admin(
            this.$route.query.admin_ID,
            this.formData.menuPermissionIDAdmin,
            this.formData.adminLoginID,
            this.formData.adminPassword,
            this.formData.adminName,
            this.formData.adminActivate
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    get_menu_permission_status_1().then((result) => {
      this.statusData.menuPermissionArray = result
    })
    if (this.$route.query.admin_ID !== undefined) {
      get_admin_one(this.$route.query.admin_ID).then((result) => {
        this.formData.adminName = result[0].admin_name
        this.formData.menuPermissionIDAdmin = result[0].menu_permission_ID
        this.formData.adminLoginID = result[0].admin_login_ID
        this.formData.adminActivate = result[0].admin_activate
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SystemManagement/AdminManagementAdd.vue